class BlockType {
	static SERVER = 'SERVER';
	static CLIENT = 'CLIENT';
	static HYBRID = 'HYBRID';
}

export default BlockType;
